module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/04_contents#racknowledgements",
      "id": "acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }, [_vm._v("To the best of my knowledge and belief, Major-General Ralph Younger, CB, CBE, DSO, MC, DL, is the only officer of the Royal Armoured Corps to have served throughout the campaign in Burma. Landing at Rangoon as second-in-command of 7th Queen’s Own Hussars, he took part in the long retreat to India, went on to command the 3rd Carabiniers during the vital Imphal battle, and was second-in-command of 255 Tank Brigade, which carried out the decisive thrust at Meiktila and led the spectacular dash to Rangoon in 1945. I am greatly honoured that he has written the Foreword to this book, and most grateful for the many hours of work that he has given to the project, for his invaluable advice and his most generous assistance in innumerable ways.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I should also like to express my appreciation to the following for their advice and time spent on my behalf: General Sir Philip Christison, GBE, CB, DSO, MC, DL; General J. N. Chaudhuri, OBE; Lt-General K. K. Singh; Major-General Sir Reginald Scoones, KBE, CB, DSO; Major-General C. E. Pert, CB, DSO; Major-General A. S. Vaidya, MVC, AVSM; Major-General Virendra Singh; Major-General Rajender Singh Sparrow, MVC; Brigadier J. H. P. Woodroffe; Brigadier H. M. Ley, CBE, DL; Brigadier Sheodan Singh, AVSM, MC; Brigadier S. M. Vohra, SM, Military Adviser to Indian High Commission, London; Brigadier M. Hussein, Military Attaché, Embassy of Pakistan, London; to Colonel J. M. Ashton, Major the Baron Dimsdale, MC, Major V. Pashley and ORQMS Knowles, late of 3rd Carabiniers; to Colonel C. T. Llewellen Palmer, MC, Colonel Marcus Fox, MC; Colonel J. F. Astley-Rushton, Colonel the Rev. N. S. Metcalfe, DSO, QHC, CF, Lt-Colonel G. S. B. Palmer, MC, Lt-Colonel J. Congreve, DSO, OBE, Captain M. J. E. Patteson, MC, MA, M.M. Stanley-Evans, Esq, MC, of 7th Queen’s Own Hussars; to Lt-Colonel Keith Ecclestone, 2nd Royal Tank Regiment, "), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }), _vm._v("for permitting access to the Regiment’s papers; to Lt-Colonel J. Blackater and Major F. J. R. Moir, MC of 116 Regiment RAC (The Gordon Highlanders); to Lt-Colonel F. W. B. Good, RTR, formerly commanding officer of 149 Regiment RAC (KOYLI); Colonel D. H. Mudie, (Royal Deccan Horse); Major O. H. M. Herford, Captain P. H. Rising, JP, Captain H. Travis and Mrs Edith Barlow, 7th Light Cavalry; Lt-Colonel F. H. Joyner, MC, TD, Major F. B. Boyd and Captain G. H. Brown, 11th (Prince Albert Victor’s Own) Light Cavalry; Colonel G. H. Critchley, Lt-Colonel E. R. McM. Wright, OBE, MC, and Major A. B. Merriam, 19th (King George V’s Own) Lancers.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I am also grateful to Colonel Peter Hordern of the RAC Tank Museum for his kind advice on the Imperial Japanese Armoured Corps and its vehicles; to Messrs Michael Joseph Ltd for permission to quote from John Master’s book, "), _c('em', [_vm._v("The Road Past Mandalay")]), _vm._v("; to Messrs Rupert Hart-Davis for permission to use extracts from Lt-Colonel Miles Smeeton’s "), _c('em', [_vm._v("A Change of Jungles")]), _vm._v("; to the Editor of "), _c('em', [_vm._v("The Tank")]), _vm._v(" magazine for the use of the poem included in "), _c('span', {
    attrs: {
      "href": "#/12_chapter3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _vm._v("; and to many others, who have helped me along the way.")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("May 1977")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right",
      "valign": "top"
    }
  }, [_vm._v("Bryan Perrett")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fa89ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_acknowledgements.vue
// module id = 81
// module chunks = 0